<template>
  <div class="cmp-wrapper">
    <basic-container>
      <el-form inline label-suffix=":" label-width="90px">
        <el-form-item label="任务编码">
          <el-input v-model="formData.taskCode"></el-input>
        </el-form-item>
        <el-form-item label="任务名称">
          <el-input v-model="formData.taskName"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formData.taskStatus" clearable>
            <el-option
              v-for="it in taskStatusList"
              :key="it.value"
              :label="it.label"
              :value="it.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否删除">
          <el-select v-model="formData.isDeleted" clearable>
            <el-option label="否" :value="0"></el-option>
            <el-option label="是" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" @click="onSearch({ page: 1 })">
            查询
          </el-button>
        </el-form-item>
      </el-form>
      <!-- <el-tabs v-model="activeName" type="card" @tab-click="handleClick" style="">
        <el-tab-pane label="全部订单" name="-1"></el-tab-pane>
        <el-tab-pane label="已提交" name="1"></el-tab-pane>
        <el-tab-pane label="已取消" name="2"></el-tab-pane>
        <el-tab-pane label="已确认" name="3"></el-tab-pane>
        <el-tab-pane label="已完成" name="4"></el-tab-pane>
      </el-tabs> -->

      <el-table v-loading="loading" :data="tableData" border stripe>
        <el-table-column label="id" prop="id" />
        <el-table-column label="任务编码" prop="taskCode" />
        <el-table-column label="任务名称" prop="taskName" />
        <el-table-column label="任务创建人" prop="taskOwnerName" />
        <el-table-column label="开始时间">
          <template slot-scope="scope">{{
            _formatDate(scope.row.startT)
          }}</template>
        </el-table-column>
        <el-table-column label="结束时间">
          <template slot-scope="scope">{{
            _formatDate(scope.row.entT)
          }}</template>
        </el-table-column>
        <el-table-column label="是否删除">
          <template slot-scope="scope">{{
            scope.row.isDeleted ? "是" : "否"
          }}</template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">{{
            taskStatusMap[scope.row.taskStatus] || "-"
          }}</template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              v-if="scope.row.isDeleted == 0"
              @click="handleDelete(scope.row)"
              >删除</el-button
            ><br />
            <el-button
              type="text"
              v-if="scope.row.taskStatus == 4"
              @click="handleDownload(scope.row)"
              >下载</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="footer pager">
        <el-pagination
          @size-change="onSearch({})"
          @current-change="onSearch({})"
          :current-page.sync="formData.page"
          :page-size.sync="formData.pageSize"
          :page-sizes="[20, 30, 40, 50]"
          layout="total, sizes, prev, pager, next, jumper"
          :total.sync="total"
          background
        ></el-pagination>
      </div>
    </basic-container>
  </div>
</template>
<script>
import { dateTimeFormatter } from "@/utils/utils.js";
import { getBaseUrl, exportFile } from "@/framework/utils/tools";

export default {
  data() {
    return {
      taskStatusList: [
        { value: 1, label: "新建" },
        { value: 2, label: "运行中" },
        { value: 3, label: "暂停" },
        { value: 4, label: "成功" },
        { value: 5, label: "失败" },
      ],
      taskStatusMap: {
        1: "新建",
        2: "运行中",
        3: "暂停",
        4: "成功",
        5: "失败",
      },
      formData: {
        pageSize: 10,
        page: 1,
        fieldOrder: "asc",
        fieldSort: "id",
        taskName: "",
        taskCode: "",
        isDeleted: "",
        taskStatus: "",
      },
      total: 0,
      loading: false,
      tableData: [],
    };
  },
  created() {
    // this.getCitys();
  },
  methods: {
    onSearch({ page }) {
      if (page) {
        this.formData.page = page;
      }
      const {
        pageSize = 10,
        fieldOrder = "asc",
        fieldSort = "id",
        taskName = "",
        taskCode = "",
        isDeleted = "",
        taskStatus = "",
      } = this.formData;
      _api
        .post("/group/get-bill-export-list", {
          pageSize: pageSize,
          page: this.formData.page,
          fieldOrder: fieldOrder || null,
          fieldSort: fieldSort || null,
          taskName: taskName || null,
          taskCode: taskCode || null,
          isDeleted: !isDeleted
            ? isDeleted === "0" || isDeleted === 0
              ? isDeleted
              : null
            : isDeleted,
          taskStatus: taskStatus || null,
        })
        .then((res) => {
          console.log(res);
          if (!res.ret) {
            this.$message.error("查询任务列表失败:" + res.message);
          } else {
            this.total = res.data.totalCount;
            this.tableData = [];
            if (res.data.items) {
              this.tableData = res.data.items;
            }
          }
        })
        .catch((e) => {
          this.$message.error("查询任务列表失败:" + e);
        });
    },
    handleDelete({ id }) {
      _api
        .post("/group/change-bill-export-task-status", {
          id,
          isDeleted: 1,
        })
        .then((res) => {
          if (res.ret) {
            this.$message.success("操作成功");
          }
        })
        .catch((e) => {
          this.$message.error("操作失败:" + e);
        })
        .finally(() => {
          this.onSearch({ page: 1 });
        });
    },
    handleStop({ id }) {
      _api
        .post("/group/change-bill-export-task-status", {
          id,
          taskStatus: 3,
        })
        .then((res) => {
          if (res.ret) {
            this.$message.success("操作成功");
          }
        })
        .catch((e) => {
          this.$message.error("操作失败:" + e);
        })
        .finally(() => {
          this.onSearch({ page: 1 });
        });
    },
    handleDownload({ filePath, unZipPwd }) {
      if (!filePath) {
        this.$message.error("所选时间区间无数据");
        return;
      }
      window.open(filePath, "_blank");
    },
    // toDetail(row){
    //   if(row){
    //     this.$router.push({
    //       path: "/orderManagement/detail",
    //       query: {
    //         storeId:row.storeId,
    //         orderId:row.orderId
    //       }
    //     });
    //   }
    // },
    _formatDate(ct) {
      return ct ? dateTimeFormatter(ct * 1000, "YYYY-MM-DD HH:mm:ss") : "--";
    },
    handleClick(tab, event) {
      // this.formData.status = this.activeName
      this.search();
    },
    search() {
      // if(!this.formData.storeId){
      //   this.$message({
      //     type: "warning",
      //     message: "请选择门店"
      //   });
      //   return;
      // }
      this.formData.pageNumber = 1;
      this.getList();
    },
    async getList() {
      this.loading = true;
      const {
        ret,
        data: { list, totalCount },
      } = await _api.bill.getList(this.formData);
      if (ret && list) {
        this.tableData = list || [];
        this.total = totalCount;
      }
      this.loading = false;
    },

    async getCitys() {
      const res = await _api.bill.getBizCitys({
        type: 1, // 1 则是美菜城市
        // status: 1 // 1开通 不传或者null 取所有
      });
      if (!res || !res.ret || !res.data) {
        this.cityList = [];
        return;
      }
      this.cityList = res.data || [];
    },
    // 重置
    reset() {
      this.formData.storeId = "";
      if (this.$refs["cusOption"]) {
        this.$refs["cusOption"].reset();
      }
      this.$refs["billManage"].resetFields();
      this.createTime = [];
    },
    handleCurrentChange(val) {
      this.getList();
    },
    handleSizeChange(val) {
      this.formData.pageNumber = 1;
      this.getList();
    },
    //导出
    async exportFile() {
      // if (this.total > 5000) {
      //   this.$message({
      //     type: "warning",
      //     message: "导出数据需≤5000条，请减少导出量"
      //   });
      //   return;
      // }
      // this.$message({
      //   type: "warning",
      //   message: "正在导出，请稍后"
      // });
      this.loading = true;
      const { ret, data } = await _api.bill.export(this.formData);

      this.loading = false;

      if (ret) {
        this.$message({
          type: "warning",
          message: data,
        });
      }

      //exportFile(`${getBaseUrl()}/dmall-manage/dmallmanage/order/export`,this.formData,'订单数据.xlsx')
    },
  },
};
</script>
<style>
.img li {
  float: left;
  margin-left: 5px;
  list-style-type: none;
}
</style>
